import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ChatMessage from 'components/Chat/ChatWindow/ChatMessage';
import ChatUtils from 'services/ChatUtils';
import { useAppSelector } from 'careand-redux/store';
import { IsPatient } from 'careand-redux/selectors';

const ChatArchive = ({ patient, archive, style }) => {
  const ownUserId = useAppSelector((state) => state.authentication.activeUserId);
  const isPatient = useAppSelector(IsPatient);
  return (
    !!archive && (
      <div className="row chat-window" key={archive?.id}>
        <div className="scroll-list messages" style={style}>
          {isPatient && (
            <div className="archive-message">
              <p>This chat has been archived.</p>
            </div>
          )}
          <List>
            <ChatMessages
              archive={archive}
              patient={patient}
              roomName={archive.id}
              ownUserId={ownUserId}
            />
          </List>
        </div>
      </div>
    )
  );
};

export const ChatMessages = ({ archive = {}, patient, ownUserId, roomName, groupedMessages }) => {
  let chatMessages = [];

  const admins = useAppSelector((state) => state.admins.byId);
  const physicians = useAppSelector((state) => state.physicians.byId);

  groupedMessages =
    groupedMessages ??
    ChatUtils.getGroupedMessages(
      archive.messages,
      ownUserId,
      patient,
      archive.attributes,
      undefined,
      admins,
      physicians,
    );

  for (let index in groupedMessages) {
    let message = groupedMessages[index];
    chatMessages.push(
      <ChatMessage
        key={index + (message.messages || []).length}
        name={message.name}
        author={message.author}
        date={message.time}
        messages={message.messages || []}
        own={message.own || message.staff}
        roomName={roomName}
      />,
    );
  }
  return chatMessages;
};

ChatArchive.propTypes = {
  patient: PropTypes.object.isRequired,
  archive: PropTypes.object,
  style: PropTypes.object,
};

export default ChatArchive;
